import { useId } from 'react'

// Ромбик-«искра» подписки Premium: путь и градиент перенесены 1:1 из веб-академии
// (Paywall → PremiumSparkles): салатовый → голубой → сиреневый.
const SPARKLE_PATH =
  'M23.9299 11.1824C18.8516 10.1178 14.8822 6.14844 13.8178 1.07C13.687 0.446591 13.1372 0 12.5 0C11.8629 0 11.313 0.446591 11.1824 1.07008C10.1178 6.14844 6.14852 10.1177 1.07016 11.1821C0.446673 11.3128 0 11.8627 0 12.4998C0 13.1369 0.446591 13.6868 1.07016 13.8175C6.14844 14.8821 10.1176 18.8513 11.1821 23.9297C11.3128 24.5532 11.8626 24.9998 12.4998 24.9998C13.1369 24.9998 13.6868 24.5532 13.8175 23.9297C14.8821 18.8513 18.8515 14.8821 23.9298 13.8177C24.5533 13.687 25 13.1372 25 12.5C24.9999 11.863 24.5533 11.313 23.9299 11.1824Z'

/**
 * Цветная звёздочка Premium. Цвета — часть бренда подписки, а не темы приложения.
 * `strokeWidth` принимается для совместимости с иконками lucide и не используется.
 */
export const PremiumStarIcon = ({
  className,
}: {
  className?: string
  strokeWidth?: string | number
}) => {
  // Свой id градиента у каждого экземпляра: `url(#id)` берёт первый такой id в документе.
  const gradientId = useId()
  return (
    <svg
      viewBox="0 0 25 25"
      fill="none"
      aria-hidden="true"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#c8e26a" />
          <stop offset="52%" stopColor="#7fc4f0" />
          <stop offset="100%" stopColor="#a98cff" />
        </linearGradient>
      </defs>
      <path d={SPARKLE_PATH} fill={`url(#${gradientId})`} />
    </svg>
  )
}
